
import { mixins, Options } from "vue-class-component";
import DetailLayout from "@/app/ui/layout/detail-layout.vue";
import Notification from "@/app/ui/components/notification/index.vue";
import OverlayPanel from "primevue/overlaypanel";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { LocationController } from "@/app/ui/controllers/LocationController";
import InputDimension from "@/app/ui/components/input-dimension/index.vue";
import InputAdornment from "@/app/ui/components/input-adornment/index.vue";
import {
  DimensionPerKoliDetail,
  CargoDetailSttPiece,
  CargoDetailBagData,
  CargoScanFailed,
  CargoStorageKey,
  CalculateVolume
} from "@/domain/entities/Cargo";
import {
  CargoData,
  CargoDetailStt,
  DimensionData,
  DimensionPerKoliData
} from "@/domain/entities/Cargo";
import {
  formatDateWithoutTime,
  formatTimeNumber,
  CARGO_SPECIAL_TYPE,
  ellipsisString,
  formatByCountry,
  formatInputByCountry,
  parseByCountry,
  checkValueOnBlurInput,
  commaDecimalToDecimal,
  parsingErrorResponse
} from "@/app/infrastructures/misc/Utils";
import Print from "@/app/ui/views/cargo/modules/print.vue";
import { CargoController } from "@/app/ui/controllers/CargoController";
import OutGoingMixins from "@/app/ui/views/out-going-shipment/out-going-mixin";
import {
  EditCargoBagOrStt,
  BagOrSttNumber,
  CalculateVolumeApiRequest, 
  CalculateVolumeRequest,
  AddBagOrStt
} from "@/data/payload/api/CargoApiRequest";
import uniqBy from "lodash/uniqBy";
import { playNotification } from "@/app/infrastructures/misc/UtilsAudio";
import { cargoTypeData, getConfigDimensionDivider, getConfigIsminimumVolumePerPiece, getConfigMinimumVolumePerPiece } from "../modules/cargo-module";
import { ResponseBagSttDetail } from "@/domain/entities/ResponsePayload";
import { TrackingController } from "@/app/ui/controllers/TrackingController";
import isFormatLiloBag from "@/app/infrastructures/misc/common-library/isFormatLiloBag";
import PopupDimensionPerKoli from "@/app/ui/views/cargo/booking-cargo/components/popup-dimension-per-koli.vue";
import { flags } from "@/feature-flags";
import DimensionPerKoli from "@/app/ui/views/cargo/booking-cargo/first-step/dimension-per-koli.vue";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";
import ScanFailedCard from "./scan-failed-card/index.vue";
import SectionUploadPhotoForWeightAdjusment from "./section-upload-photo-for-weight-adjustment/index.vue";
import { UploadMultiple, ModalMessageEntities } from "@/domain/entities/MainApp";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { DeleteHydraFileRequest, UploadHydraFileRequest } from "@/data/payload/api/BookingRequest";
import WeightSummaryStt from "@/app/ui/views/cargo/booking-cargo/first-step/weight-summary-stt.vue";
import WeightSummaryTimbangUlang from "@/app/ui/views/cargo/booking-cargo/first-step/weight-summary-timbang-ulang.vue";
import { CALCULATE_TYPE } from '../modules/cargo-module';
import { RequestCheckEligibleReadyToCargo } from '@/domain/entities/ReadyToCargo';
import { nextTick } from 'vue';

@Options({
  components: {
    DetailLayout,
    OverlayPanel,
    Notification,
    InputDimension,
    InputAdornment,
    Print,
    PopupDimensionPerKoli,
    DimensionPerKoli,
    ScanFailedCard,
    SectionUploadPhotoForWeightAdjusment,
    WeightSummaryStt,
    WeightSummaryTimbangUlang,
  },
  watch: {
    // "detailData.cargoActualPiece": {
    //   handler: function(val: number) {
    //     this.calculationVolumeWeight(val)
    //   },
    //   deep: true
    // },
    "detailData.totalActualCargoGrossWeight": {
      handler(val: string) {
        if (
          !val ||
          this.showNewDimensionPerKoli ||
          !this.isValidationAdjustWeightProofPhotoEnable
        )
          return;
        const grossWeightDiff = +(
          parseByCountry(typeof val === "string" ? val : String(val), { country: this.countryCode }) -
          parseByCountry(typeof this.totalGrossWeight === "string" ? this.totalGrossWeight : String(this.totalGrossWeight), { country: this.countryCode })
        ).toFixed(2);
        if (!this.isTempGrossWeightSet) {
          this.tempGrossWeight = val;
          this.isTempGrossWeightSet = true;
        }
        if (this.isFirstLanding) {
          this.isGrossWeightChanged =
            (parseByCountry(typeof val === "string" ? val : String(val), { country: this.countryCode }) -
            parseByCountry(typeof this.tempGrossWeight === "string" ? this.tempGrossWeight : String(this.tempGrossWeight), { country: this.countryCode })) !== 0
          if (this.isGrossWeightChanged) this.isFirstLanding = false;
          else return;
        }
        if (grossWeightDiff >= 1) {
          this.isGrossWeightDiff = true;
        } else {
          this.isGrossWeightDiff = false;
        }
      },
      immediate: true
    }
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    if (to.name === "login") {
      next();
    }
    if (!this.openSuccess && !this.isPartial) {
      this.onOpenClosePage(to);
      if (this.answer) {
        this.resetUploadPhotoCondition();
        this.answer = false;
        next();
      } else {
        next(false);
      }
    } else {
      next();
      this.setOpenSuccess(false);
      this.resetUploadPhotoCondition();
    }
  }
}
)
export default class Edit extends mixins(OutGoingMixins) {
  get countryCode() {
    return AccountController.accountData?.countryCode ?? "ID";
  }

  pagination = {
    page: 1,
    limit: 50
  };
  editDimensionPerKoli = false;
  notificationTimeout?: NodeJS.Timeout = undefined;
  isGrossWeightDiff = false;
  openAdjustmentWeight = true;
  isFirstLanding = true;
  isGrossWeightChanged = false;
  photoProof: string[] = [];
  tempGrossWeight = 0;
  isTempGrossWeightSet = false;

  get isValidationAdjustWeightProofPhotoEnable() {
    return (
      FlagsPermissionCargo.validation_adjust_weight_proof_photo_enable.isEnabled() &&
      this.detailData.isAllowUseProof
    );
  }

  get originAirport() {
    return ellipsisString(
      `${this.detailData.airportOriginCityCode} - ${this.detailData.airportOriginCityName}`,
      11
    );
  }
  get destinationAirport() {
    return ellipsisString(
      `${this.detailData.airportDestinationCityCode} - ${this.detailData.airportDestinationCityName}`,
      11
    );
  }
  mounted() {
    CargoController.setIsDimensionSaved(false);
    CargoController.setIsSttUpdated(false);
    this.fetchDetailData();
    this.setCargoFailedScanFromStorage();
  }

  async fetchDetailData() {
    const isPrint = false;
    await CargoController.getDetailCargo({
      id: this.cargoId,
      isPrint: isPrint
    });

    await this.$nextTick();
    this.mappingDimensionPerKoli();
    this.formEdit.cargoType = this.detailData.cargoType;
    this.formEdit.cargoTypeStatus = this.detailData.isPlaneManual ? "manual" : "auto";
    CargoController.setOnChangeTotalActualGrossWeight(
      formatByCountry(this.parseNumber(this.detailData.totalActualCargoGrossWeight), { type: "weight", country: this.countryCode }) as any
    );
    CargoController.setOnChangeTotalColi(this.detailData.cargoActualPiece);
    CargoController.setOnChangeDimension({
      height: this.detailData.actualDimension.height,
      length: this.detailData.actualDimension.length,
      width: this.detailData.actualDimension.width
    })
    CargoController.setIsCargoDimensionOn(this.detailData.isCargoDimensionOn);
    CargoController.setInitCalculateVolumeData(new CalculateVolume({
      chargeableWeight: this.detailData.currentChargeableWeight,
      calculateType: this.detailData.calculateType
    }));
    this.calculateVolume(this.detailData.calculateType, false, true);
    if (this.detailData.calculateType === "INIT") this.isDimensionChanged = false;
    else this.isDimensionChanged = true;
    // this.calculationVolumeWeight(this.detailData.cargoActualPiece)
  }

  get formEdit() {
    return CargoController.form;
  }

  async mappingActualCargoWeight() {
    await this.$nextTick();
    this.formEdit.actualTotalCargoGrossWeight = this.convertDecimal(
      this.totalNewCalculationGrossWeights
    ) as string;
    this.formEdit.actualTotalCargoVolumeWeight = this.convertDecimal(
      Math.round(this.totalNewCalculationVolumeWeights)
    ) as string;
    await this.$nextTick();

  }

  onEdit() {
    this.editDimensionPerKoli = true;
  }

  get isSttUpdated(): boolean {
    return CargoController.isSttUpdated;
  }

  get summary(): DimensionPerKoliData {
    return CargoController.dimensionPerKoliDataEdit;
  }

  get errorSummary(): string {
    if (this.summary.totalPieces > 15) {
      CargoController.setErrorMaxPieces(true);
      return "Total koli melebihi batas";
    }

    if (
      this.summary.actualGrossWeight > 400 ||
      this.summary.actualVolumeWeight > 400
    ) {
      CargoController.setErrorMaxGrossWeight(true);
      return "Total berat melebihi batas";
    }

    CargoController.setErrorMaxPieces(false);
    CargoController.setErrorMaxGrossWeight(false);
    return "";
  }

  get departureDate() {
    return new Date(this.detailData.departureDate);
  }

  get arrivalDate() {
    return new Date(this.detailData.arrivalDate);
  }

  get cargoNo(): string {
    return decodeURIComponent(String(this.$route.params?.id));
  }

  get cargoId(): string | number {
    return this.$route.query.id as string;
  }

  get isSttEmpty(): boolean {
    return !this.sttResultFinal?.length;
  }
  
  get isUploadPhotoAdjustWeightValid() {
    if (this.isEditFirstLanding) return true;
    const isError = this.isErrorChargeableWeight;
    return isError && this.isValidationAdjustWeightProofPhotoEnable
      ? this.photoProof.filter((photo) => photo).length > 0
      : true;
  }

  get isFormValid() {
    return (
      (
        this.parseNumber(this.formEdit.actualTotalCargoVolumeWeight) &&
        this.parseNumber(this.formEdit.actualTotalCargoGrossWeight) &&
        this.parseNumber(this.formEdit.actualTotalSTTPieces as any) &&
        this.isDimension &&
        !this.isSttEmpty &&
        this.isUploadPhotoAdjustWeightValid &&
        !this.isErrorTimbangUlang &&
        !CargoController.isExceedMaxDisputeWeight &&
        !CargoController.isBagOnlyExceedMaxDisputeWeight
      ) || (this.isSttEmpty && this.sttResult?.length)
    );
  }
  get isErrorTimbangUlang() {
    if (!this.isPlaneAuto) return false;

    return (
      CargoController.isErrorMaxGrossWeight || CargoController.isErrorMaxPieces
    );
  }

  get isDimension() {
    return (
      this.formEdit.actualDimension.height &&
      this.formEdit.actualDimension.width &&
      this.formEdit.actualDimension?.length &&
      this.isDimensionPerKoliValidation
    );
  }

  get isDimensionPerKoliValidation() {
    return this.showNewDimensionPerKoli ? (
      CargoController.dimensionPerKoliDataEdit?.actualVolumeWeight <= 400 &&
      CargoController.dimensionPerKoliDataEdit?.actualGrossWeight <= 400 
    ) : true
  }

  get detailData(): CargoData {
    return CargoController.cargoDetailData;
  }

  get cargoType() {
    return cargoTypeData(this.detailData.cargoType);
  }

  get sttResult(): CargoDetailStt[] {
    const sttResult: any = CargoController.cargoDetailData.detailStt;
    return sttResult;
  }

  get sttResultTable() {
    return this.sttResult.filter(item => item.action !== "remove");
  }

  get sttResultFinal() {
    const tempData: any = [];
    if (this.sttResultTable) {
      this.sttResultTable.forEach((e: any) => {
        const existingIdx = tempData.findIndex(
          (a: any) => a.baggingNumber === e.baggingNumber
        );
        if (e.baggingNumber) {
          if (existingIdx > -1) {
            tempData[existingIdx]["sttDetails"].push(e);
          } else {
            tempData.push({ ...e, sttDetails: [e] });
          }
          return;
        }
        tempData.push({ ...e, sttDetails: [e] });
      });
    }
    CargoController.setSTTResultFinal(tempData);
    return tempData;
  }

  // delete stt number
  sttNumberListTrash: Array<string> = [];
  showDeleteSttNumber = false;
  sttNumberToDelete = "";
  sttNumberSuccessDelete = "";
  errorSttNumberDelete = "";
  async onValidateDeleteSttNumber(val: any) {
    const splitVal = val.split("#");
    if (splitVal?.length > 0) this.sttNumberToDelete = splitVal[0];
    this.onDeleteSttNumber();
  }

  get isSttNo() {
    return /^\d/.test(this.sttNumberToDelete); // check if sttNo or bagNo
  }

  // find index no. stt
  get indexSttNumber() {
    return this.isSttNo
      ? this.sttResult.findIndex(data => {
          return (
            (data.sttNumber === this.sttNumberToDelete ||
              data.sttElexysNumber === this.sttNumberToDelete) &&
            data.action !== "remove"
          );
        })
      : -1;
  }

  // find index no. bag
  get indexBagNumber(): number[] {
    return this.isSttNo
      ? []
      : this.sttResult.reduce((a: number[], b, i) => {
          return a.concat(
            b.baggingNumber === this.sttNumberToDelete && b.action !== "remove"
              ? i
              : []
          );
        }, []);
  }

  onDeleteSttNumber() {
    if (this.sttNumberToDelete) {
      this.errorSttNumberDelete = "";
      this.sttNumberSuccessDelete = "";
      this.sttNumberToDelete = this.sttNumberToDelete.toUpperCase();

      const removeSttNo = (index: number) => {
        this.sttNumberListTrash.push(this.sttResult[index].sttNumber);
        if (this.sttResult[index].action !== "add")
          this.sttResult[index].action = "remove";
        else this.sttResult.splice(index, 1);

        this.sttNumberSuccessDelete = this.sttNumberToDelete;
        this.sttNumberToDelete = "";
      };

      // no. stt not found
      if (this.indexSttNumber < 0 && this.indexBagNumber?.length === 0) {
        this.errorSttNumberDelete =
          this.$t("No. STT/No. Bag tidak ditemukan atau sudah terhapus");
      } else {
        this.isSttNo
          ? removeSttNo(this.indexSttNumber)
          : this.indexBagNumber.forEach(() => {
              removeSttNo(this.indexBagNumber[0]);
            });
      }

      if (this.isSttEmpty) {
        this.detailData.actualDimension = new DimensionData({
          length: 30,
          width: 20,
          height: 10
        });
        this.detailData.totalActualCargoVolumeWeight = 0;
      }
      this.isDimensionChanged = false;
      CargoController.setOnChangeTotalColi(CargoController.totalSttPieces);
      CargoController.setOnChangeTotalActualGrossWeight(
        this.totalNewCalculationGrossWeights
      );
      this.calculateVolume(CALCULATE_TYPE.INIT, true);
    }
  }

  // get profile account
  get dataProfile() {
    return AccountController.accountData;
  }
  get detailDistrict() {
    return LocationController.districtDetail;
  }
  get typeUser() {
    return this.detailData.partnerType === "console"
      ? "Consolidator"
      : "Subconsolidator";
  }

  get sttDetail() {
    return TrackingController.trackingSttData.sttDetail;
  }

  // handle stt number
  errorSttNumber = "";
  isValidateScan = false;

  savedSttNo = "";
  savedCargoType = "";
  savedCargoNumber = "";

  onResetForm() {
    this.scanNumber = "";
    this.form.sttNumber = "";
    this.isErrorValidationScan = false;
    this.errorSttNumber = "";
    this.isErrorTyping = false;
    // re focus
    const inputStt: any = this.$refs.inputStt;
    inputStt?.focus();
  }

  //via scan
  isScan = false;
  addScanSttNumber(val: any) {
    if (!this.isDisableAddSttNumber) {
      const splitVal = val.split("#");
      this.form.sttNumber = `${splitVal[0]}`;
      this.isScan = true;
      this.form.sttNumber && this.addSttNumberToUpdate();
    }
  }

  addSttNumber() {
    if (!this.isDisableAddSttNumber) {
      this.isScan = false;
      const splitVal = this.scanNumber.split("#");
      this.form.sttNumber = `${splitVal[0]}`;
      this.form.sttNumber && this.addSttNumberToUpdate();
    }
  }

  checkSttorBagFormatNumber(value: string) {
    const sttPatern = /^\d{2}[a-z]{2}/; // check for stt number
    const bagPattern = /^[a-z]{3}-\d+$/; // check for bag number
    return sttPatern.test(value.toLocaleLowerCase()) || bagPattern.test(value.toLocaleLowerCase());
  }

  checkSttFromLilo(value: string) {
    return isFormatLiloBag(value)
  }

  scanNumber = "";
  get totalNewCalculationGrossWeights() {
    return CargoController.totalNewCalculationGrossWeights;
  }

  get totalNewCalculationVolumeWeights() {
    return CargoController.totalNewCalculationVolumeWeights;
  }
  get isScanStt() {
    return /^\d/.test(this.form.sttNumber);
  }
  async addSttNumberToUpdate() {
    const isCheckTrackingSttFirst = !this.checkSttorBagFormatNumber(
      this.form.sttNumber.trim()
    ); // this is for checking if it need to use tracking stt endpoint or not

    const isSttFromLilo = this.checkSttFromLilo(this.form.sttNumber.trim());

    const inputStt = this.form.sttNumber;
    let generatedStt = this.scanNumber.trim();

    if (isCheckTrackingSttFirst && !isSttFromLilo) {
      await TrackingController.trackStt({
        sttNo: this.form.sttNumber.trim(),
        isGetSla: false,
        isSecondCall: false,
        cache: true
      }).then(isSuccess => {
        if (isSuccess) {
          this.form.sttNumber = this.sttDetail.sttNo;
          generatedStt = this.sttDetail.sttNo;
        }
      })
    }

    let bagNumber = "";
    let sttNumber = "";

    if (!this.isScanStt) {
      bagNumber = this.form.sttNumber.trim();
    } else {
      sttNumber = this.form.sttNumber.trim();
    }
    let payload: any = {
      bagOrStt: new BagOrSttNumber(bagNumber, sttNumber),
      cargoProductType: this.detailData.cargoProductCode,
      cargoCommodity: this.detailData.cargoCommodityCode,
      cargoType: this.detailData.cargoType,
      callback: this.addStt,
      storageKey: CargoStorageKey.FailedListEdit
    };
    payload = this.isInternal
      ? { ...payload, partnerId: this.detailData.partnerId }
      : payload;
    await CargoController.appendBagOrSttNumber(payload).then(() => {
      if (isCheckTrackingSttFirst && !isSttFromLilo) {
        this.sttResult.forEach(item => {
          if (item.sttNumber.toLowerCase() == generatedStt.toLowerCase()) {
            item.sttNoRefExternal = inputStt.trim();
          }
          return item;
        });
      }
    });
    await this.$nextTick();
    this.isDimensionChanged = false;
    CargoController.setOnChangeTotalColi(CargoController.totalSttPieces);
    CargoController.setOnChangeTotalActualGrossWeight(
      this.parseNumber(
        this.convertDecimal(this.totalNewCalculationGrossWeights) as string
      )
    );
    this.calculateVolume(CALCULATE_TYPE.INIT, true);
  }

  addStt(fetchBagOrStt: any) {
    this.isErrorNotification = false;
    this.errorSttNumber = "";

    if (fetchBagOrStt) {
      const detailSTT = CargoController.bagSttDetail;
      const bagOrStt = detailSTT.bagOrStt || [];

      const checkErrorSttNeedAssessment = bagOrStt.find((item: any) =>
        ["waiting", "rejected"].includes(item.stt_assessment_status)
      );

      if (checkErrorSttNeedAssessment) {
        playNotification("error");
        this.errorSttNumber =
          "Gagal scan karena adjustment STT belum disetujui tim Lion Parcel, tunggu dihubungi CS.";
        this.messageErrorNotification =
          "Adjustment STT belum disetujui tim Lion Parcel, tunggu follow up dari CS.";

        for (const detail of detailSTT.bagOrStt) {
          this.onFailedAddStt(detail);
        }

        this.addToScanFailedList(
          new CargoScanFailed({
            sttNumber: this.form.sttNumber,
            lastStatus: detailSTT.lastStatus,
            failureReason: this.errorSttNumber
          })
        );

        clearTimeout(this.notificationTimeout as NodeJS.Timeout);
        this.notificationTimeout = setTimeout(() => {
          this.notification = false;
        }, 15000);
      } else if (detailSTT.isAllowUpdateStatus) {
        const isBagOrNot = detailSTT.bagOrStt?.find(
          (item: any) => item.bag_no !== ""
        );
        const isBaggingOnTable = this.sttResultFinal?.find(
          (item: any) =>
            item.baggingNumber === detailSTT.bagOrStt[0].bag_no && isBagOrNot
        );

        this.onProcessCargoData(detailSTT);
      } else {
        playNotification("error");
        this.errorSttNumber = this.$t(detailSTT.errorMessage);

        this.addToScanFailedList(
          new CargoScanFailed({
            sttNumber: this.form.sttNumber,
            lastStatus: detailSTT.lastStatus,
            failureReason: this.errorSttNumber
          })
        );
      }
    }
  }

  baggingAccumulate(isBagOrNot: any, detailSTT: ResponseBagSttDetail) {
    let accumulate = 0;
    if (isBagOrNot && this.detailData.cargoType === CARGO_SPECIAL_TYPE)
      accumulate = 1;
    else {
      accumulate = detailSTT.bagOrStt.reduce((acc: any, curr: any) => {
        return acc + curr.stt_total_piece;
      }, 0);
    }
    return accumulate;
  }

  onProcessCargoData(detailSTT: any) {
    for (const detail of detailSTT.bagOrStt) {
      const indexCurrentSttNumber = this.sttResult.findIndex(data => {
        return data.sttNumber === detail.stt_no;
      });

      if (indexCurrentSttNumber > -1) {
        this.addToScanFailedList(
          new CargoScanFailed({
          sttNumber: this.form.sttNumber,
          success: true
        }))

        if (this.sttResult[indexCurrentSttNumber].action === "remove") {
          this.sttResult[indexCurrentSttNumber].action = "";
        } else {
          playNotification("error");
          this.errorSttNumber = this.$t("No. STT sudah di input");
        }
        return;
      } else if (!detail.is_paid) {
        this.isUnpaid = true;
        this.isErrorNotification = true;
        this.messageErrorNotification =
          this.$t("Tunggu sampai customers selesai melunasi tagihan kurang bayar");
        this.errorSttNumber =
          this.$t("Terjadi kelebihan berat sehingga status tidak dapat diupdate ke Cargo.");
        playNotification("error");

        this.addToScanFailedList(
          new CargoScanFailed({
            sttNumber: this.form.sttNumber,
            lastStatus: detailSTT.lastStatus,
            failureReason: this.errorSttNumber
          })
        );
      } else {
        this.pushDataStt(detail);
        playNotification("success");

        this.addToScanFailedList(
          new CargoScanFailed({
          sttNumber: this.form.sttNumber,
          success: true
        }))
      }

      this.updateDimensionPerKoliData();
      CargoController.setIsSttUpdated(CargoController.isDimensionSaved);

      this.detailSttNotification = {
        sttNumber: detail.stt_no,
        sttElexysNumber: detail.stt_no_elexys,
        product: detail.product_type,
        commodity: detail.commodity_name,
        totalPieces: detail.stt_total_piece,
        destinationCity: `${this.detailData.destinationCityCode} - ${this.detailData.destinationCityName}`
      };
      // reset form
      this.savedSttNo = this.form.sttNumber;
      this.scanNumber = "";
      this.form.sttNumber = "";
      if (!this.isErrorValidationScan) {
        this.isValidateScan = false;
        this.onEditStt();
      }
      this.notification = true;
      // re focus
      const inputStt: any = this.$refs.inputStt;
      inputStt?.focus();

      // remove notification after 15 second
      if (!this.isUnpaid) {
        clearTimeout(this.notificationTimeout as NodeJS.Timeout)
        this.notificationTimeout = setTimeout(() => {
          this.notification = false;
        }, 15000);
      }      
    }
  }

  get scanFailedList(): CargoScanFailed[] {
    return CargoController.scanFailedList;
  }
  addToScanFailedList(data: CargoScanFailed) {
    CargoController.addScanFailedList(
      new CargoScanFailed({
        ...data,
        storageKey: CargoStorageKey.FailedListEdit
      })
    );
  }
  setCargoFailedScanFromStorage() {
    CargoController.setScanFailedListFromStorage(CargoStorageKey.FailedListEdit);
  }
  onResetCargoFailedScanFromStorage() {
    CargoController.resetScanFailedList();
  }


  updateDimensionPerKoliData() {
    // Extract total pieces and dimension pieces from CargoController
    const { dimensionPieces } = CargoController.dimensionPerKoliDataEdit;

    // Create a new data array by mapping over existing data
    const mappingKoliData = this.sttResultFinal.flatMap((item: any) =>
      item.baggingNumber && this.hasBagDimensions(item.bagData)
        ? [this.createBagDimensionDetail(item)]
        : this.createPieceDimensionDetails(item)
    );

    // Update dimension per koli details with existing and new data
    const updatedDimensionPerKoli: DimensionPerKoliDetail[] = mappingKoliData.filter(
      (newItem: DimensionPerKoliDetail) =>
        !dimensionPieces.some(
          (existing: DimensionPerKoliDetail) =>
            existing.sttOrBag === newItem.sttOrBag
        )
    );

    // Set the updated dimension per koli data to CargoController
    CargoController.setDimensionPerKoliDataEdit(
      new DimensionPerKoliData({
        dimensionPieces: [...dimensionPieces, ...updatedDimensionPerKoli]
      })
    );
  }

  getSttOrBagPieces(detail: any): string {
    return detail.bag_vendor_no || detail.bag_no || detail.stt_no;
  }

  mapSttPieces(detail: any, sttOrBagPieces: string): DimensionPerKoliDetail[] {
    return detail?.stt_pieces?.map((item: any) => 
          new DimensionPerKoliDetail({
            sttOrBag: sttOrBagPieces,
            totalPieces: item.length,
            sttPieceLength: item.stt_piece_length,
            sttPieceWidth: item.stt_piece_width,
            sttPieceHeight: item.stt_piece_height,
            sttPieceGrossWeight: item.stt_piece_gross_weight,
            sttPieceVolumeWeight: item.stt_piece_volume_weight
          })
        ) || [];
    }

  updateCargoDimensions(sttPieces: DimensionPerKoliDetail[]): void {
    const totalSttPieces = sttPieces.length;
    const sttDimension = [
      ...CargoController.dimensionPerKoliDataEdit.dimensionPieces, 
      ...sttPieces
    ];
    const sttActualGrossWeight = sttPieces.reduce(
      (total, item) =>
        total +
        (item.sttPieceGrossWeight
          ? commaDecimalToDecimal(item.sttPieceGrossWeight)
          : 0),
      0
    );
    const actualVolumeWeight = sttPieces.reduce(
      (total, item) =>
        total +
        (item.sttPieceVolumeWeight
          ? commaDecimalToDecimal(item.sttPieceVolumeWeight)
          : 0),
      0
    );

    CargoController.setDimensionPerKoliDataEdit(
      new DimensionPerKoliData({
        actualGrossWeight: sttActualGrossWeight,
        actualVolumeWeight: actualVolumeWeight,
        totalPieces: totalSttPieces,
        dimensionPieces: sttDimension
      })
    );
  }

  onFailedAddStt(detailSTT: any) {
    this.detailSttNotification = {
      sttNumber: detailSTT.stt_no,
      destinationCity: `${detailSTT.destination_city_code} - ${detailSTT.destination_city_name}`,
    };
    this.isErrorNotification = true;
    this.notification = true;
  }

  pushDataStt(detail: any) {
    this.sttResult.push(
      new CargoDetailStt({
        bagCustomChargeableWeight: detail?.bag_data?.bag_custom_chargeable_weight,
        chargeableWeight: detail?.chargeable_weight,
        baggingNumber: detail.bag_no,
        baggingVendorNumber: detail.bag_vendor_no,
        sttNumber: detail.stt_no,
        totalPieces: detail.stt_total_piece,
        grossWeigth: detail.gross_weight,
        volumeWeight: detail.volume_weight,
        productType: detail.product_type,
        commodity: detail.commodity_name,
        action: "add",
        commodityGroupCode: detail.commodity_group_code,
        commodityGroupName: detail.commodity_group_name,
        bagData: this.createBagData(detail),
        sttPieces: detail?.stt_pieces?.map(
          (item: any) =>
              new CargoDetailSttPiece({
                sttPieceLength: item?.stt_piece_length,
                sttPieceWidth: item?.stt_piece_width,
                sttPieceHeight: item?.stt_piece_height,
                sttPieceGrossWeight: item?.stt_piece_gross_weight,
                sttPieceVolumeWeight: item?.stt_piece_volume_weight
              })
          ),
        isScanByBag: !this.isScanStt,
        sttClientId: detail.stt_client_id
      })
    );
  }

  createBagData(detail: any) {
    return new CargoDetailBagData({
      bagCustomGrossWeight: this.getBagCustom(detail),
      bagCustomVolumeWeight: detail?.bag_data?.bag_custom_volume_weight || 0,
      bagCustomChargeableWeight: detail?.bag_data?.bag_custom_chargeable_weight || 0,
      bagGrossWeight: this.getBagGross(detail),
      bagCustomLength: this.getBagLength(detail),
      bagCustomWidth: this.getBagWidth(detail),
      bagCustomHeight: this.getBagHeight(detail) 
    });
  }

  getBagCustom(detail: any) {
    return detail?.bag_data?.bag_custom_gross_weight || 0;
  }

  getBagGross(detail: any) {
    return detail?.bag_data?.bag_gross_weight;
  }

  getBagLength(detail: any) {
    return detail?.bag_data?.bag_custom_length;
  }

  getBagWidth(detail: any) {
    return detail?.bag_data?.bag_custom_width;
  }

  getBagHeight(detail: any) {
    return detail?.bag_data?.bag_custom_height;
  }
  
  // change cargo actual piece and total actual gross weight when add or remove stt
  onEditStt() {
    this.detailData.cargoActualPiece = this.countPcs;
    this.detailData.totalActualCargoGrossWeight = this.totalGrossWeight;
    const actualCargoVolumeWeight = this.getActualCargoWeight(
      CargoController.dimensionPerKoliDataEdit.actualVolumeWeight,
      this.detailData.totalActualCargoVolumeWeight
    );
    this.detailData.totalActualCargoVolumeWeight = actualCargoVolumeWeight;
  }

  isDiffDestination = false;
  messageErrorNotification = "";
  onCloseNotification() {
    this.isUnpaid = false;
    this.isErrorNotification = false;
    this.isDiffDestination = false;
    this.errorSttNumber = "";
    this.notification = false;
  }

  get totalStt() {
    return this.sttResultTable?.length;
  }

  get totalPieces() {
    return this.detailData.totalPiecesBagStt;
  }

  set totalPieces(newValue) {
    this.detailData.totalPiecesBagStt = newValue;
  }

  get totalGrossWeight() {
     const seen = new Map();
    const data: CargoDetailStt[] = [];

    for (const item of this.sttResultTable) {
      const { baggingNumber } = item;

      if (!baggingNumber) {
        data.push(item);
        continue;
      }

      if (!seen.has(baggingNumber)) {
        const entry = { ...item, sttDetails: [item] };
        data.push(entry);
        seen.set(baggingNumber, entry);
      } else {
        // Deep reference, so the existing entry will be updated in seen and data
        seen.get(baggingNumber).sttDetails.push(item);
      }
    }

    return data.reduce((a, b) => {
      return (
        a +
        (b.isScanByBag ? b.bagData.bagCustomGrossWeight : b.grossWeigth)
      );
    }, 0);
  }
  get totalVolumeWeight() {
    return this.sttResultTable.reduce((a, b) => {
      return a + b.volumeWeight;
    }, 0);
  }

  get shcValue() {
    return (
      `${this.detailData.shcCode} - ${this.detailData.shcDescription}` || "-"
    );
  }

  // alert popup
  isErrorTyping = false;
  isErrorValidationScan = false;
  isPartial = false;
  get sttFailedUpdate() {
    return CargoController.sttFailed;
  }
  setPartial(value: boolean) {
    this.isPartial = value;
  }
  get alertPopup() {
    // if success
    if (this.openSuccess)
      return {
        onClick: () => this.onCloseSuccess(),
        title: this.$t("cargo.titlePopupEditCargo"),
        message: this.$t("cargo.subtitlePopupEditCargo", {cargoNo: CargoController.cargoIdToGeneratePdf}),
        image: "image-modal-success"
      };
    // if success partially
    if (this.isPartial)
      return {
        onClick: () => this.onCloseSuccess(),
        onDownload: () => this.onDownloadCsvFailedStt(this.sttFailedUpdate),
        title: this.$t("cargo.titlePopupEditCargo"),
        message: this.$t("cargo.subtitlePartialEditCargo", {cargoNo: CargoController.cargoIdToGeneratePdf}),
        image: "image-modal-warning"
      };
    // default is failed
    return {
      onClick: () => this.setFailed(false),
      onDownload: () => this.onDownloadCsvFailedStt(this.sttFailedUpdate),
      title: this.$t("Perubahan Gagal !"),
      message: this.$t("Pengiriman kargo gagal diubah."),
      image: "image-modal-failed"
    };
  }

  onDownloadCsvFailedStt(data: any) {
    this.downloadCsvFailedStt({
      fileName: "cargo_stt_failed.csv",
      listStt: data
    });
  }

  isUnpaid = false;
  isErrorNotification = false;

  // form model
  form = {
    sttNumber: ""
  };

  get isDisableAddSttNumber() {
    return !this.scanNumber;
  }

  get countPcs() {
    // STTs with the same bagNo counted as one, STTs without bagNo counted per totalPieces
    const sttUniqByBag = uniqBy(
      this.sttResultTable.filter(item => item.baggingNumber),
      "baggingNumber"
    );
    const sttWithoutBag = this.sttResultTable.filter((item) => !item.baggingNumber);
    const result = [...sttUniqByBag, ...sttWithoutBag].reduce((a, b) => {
      return a + (b.baggingNumber ? 1 : b.totalPieces);
    }, 0);
    return result;
  }

  get minimumWeight() {
    return FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue();
  }
  get volumeWeightFlag() {
    return this.minimumWeight !== 0;
  }

  calculationVolumeWeight(countPcs: number) {
    // totalActualCargoVolumeWeight
    // flag !== 0 ? totalActualCargoVolumeWeight < flag ? totalActualCargoVolumeWeight = flag : totalActualCargoVolumeWeight
    const divider = getConfigDimensionDivider(this.detailData.cargoType);
    const total =
      ((this.detailData.actualDimension?.length *
        this.detailData.actualDimension.width *
        this.detailData.actualDimension.height) /
      divider) * countPcs;

    const volume = total < 1 && total > 0 ? "1" : Math.round(total).toString();
    const volumeWeightValue =
      this.volumeWeightFlag
      ? Number(volume) < Number(this.minimumWeight)
        ? this.minimumWeight
        : volume
      : volume;
    
    this.detailData.totalActualCargoVolumeWeight = volumeWeightValue.toString();
  }

  // convert value decimal
  convertDecimal(value: any): string {
    return formatByCountry(Number(value), { type: "weight", country: this.countryCode });
  }

  // panel pickup
  togglePanel(event: any) {
    const refs: any = this.$refs;
    refs.op?.toggle(event);
  }

  // notification handler
  notification = false;
  detailSttNotification: any = null;

  // table
  get columns() {
    return [
      {
        name: "No.",
        styleHead: "w-10 text-center whitespace-nowrap",
        styleCustom: "align-center",
        render: (_: any, index: number) => {
          return `<div class="text-black-lp-300">${index +
            1 +
            this.pagination.limit * (this.pagination.page - 1)}</div>`;
        }
      },
      {
        name: "No. bag",
        styleHead: "w-40 text-left whitespace-nowrap",
        render: (item: CargoDetailStt) => {
          return `<div class="text-black-lp-300 whitespace-nowrap">
                  ${item.baggingVendorNumber || item.baggingNumber || "-"}
                </div>`;
        }
      },
      {
        name: "Chargeable bag",
        styleHead: "w-32 text-left whitespace-no-wrap",
        render: (item: CargoDetailStt) => {
          return `<div class="text-black-lp-300 whitespace-no-wrap">
              ${
                item.bagCustomChargeableWeight
                  ? formatByCountry(item.bagCustomChargeableWeight, { type: "weight", country: this.countryCode }) + " kg"
                  : "-"
              }
            </div>`;
        }
      },
      {
        name: "No. STT",
        styleHead: "w-40 text-left whitespace-no-wrap",
        render: (item: any) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails) {
            for (const x in item.sttDetails) {
              html += `<div class="text-black-lp-300">${item.sttDetails[x].sttNumber}</div>`;
            }
            html += `</div>`;
            return html;
          }
          return `<div class="text-black-lp-300 whitespace-no-wrap">
                  ${item.sttNumber}
                </div>`;
        }
      },
      {
        name: this.$t("No. Referensi"),
        styleHead: "w-40 text-left whitespace-no-wrap",
        render: (item: any) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails) {
            for (const x in item.sttDetails) {
              html += `<div class="text-black-lp-300">${item.sttDetails[x].sttNoRefExternal || "-"}</div>`;
            }
            html += `</div>`;
            return html;
          }
          return `<div class="text-black-lp-300 whitespace-no-wrap">
                  ${item.sttNoRefExternal || "-"}
                </div>`;
        }
      },
      {
        name: "Chargeable weight STT",
        styleHead: "w-32 text-left whitespace-no-wrap",
        render: (item: any) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails) {
            for (const x in item.sttDetails) {
              html += `<div class="text-black-lp-300">${formatByCountry(item.sttDetails[x].chargeableWeight, { type: "weight", country: this.countryCode })} kg</div>`;
            }
            html += `</div>`;
            return html;
          }
          return `<div class="text-black-lp-300 whitespace-no-wrap">
                  ${formatByCountry(item.chargeableWeight, { type: "weight", country: this.countryCode })} kg
                </div>`;
        }
      },
      {
        name: this.$t("Berat kotor STT"),
        styleHead: "w-32 text-left whitespace-no-wrap",
        render: (item: any) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails) {
            for (const x in item.sttDetails) {
              html += `<div class="text-black-lp-300">${formatByCountry(item.sttDetails[x].grossWeigth, { type: "weight", country: this.countryCode })} kg</div>`;
            }
            html += `</div>`;
            return html;
          }
          return `<div class="text-black-lp-300 whitespace-no-wrap">
                  ${formatByCountry(item.grossWeigth, { type: "weight", country: this.countryCode })} kg
                </div>`;
        }
      },
      {
        name: this.$t("Berat volume STT"),
        styleHead: "w-32 text-left whitespace-no-wrap",
        render: (item: any) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails) {
            for (const x in item.sttDetails) {
              html += `<div class="text-black-lp-300">${formatByCountry(item.sttDetails[x].volumeWeight, { type: "weight", country: this.countryCode })} kg</div>`;
            }
            html += `</div>`;
            return html;
          }
          return `<div class="text-black-lp-300 whitespace-no-wrap">
                  ${formatByCountry(item.volumeWeight, { type: "weight", country: this.countryCode })} kg
                </div>`;
        }
      },
      {
        name: this.$t("Total Koli"),
        styleHead: "w-24 text-left whitespace-no-wrap",
        render: (item: any) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails) {
            for (const x in item.sttDetails) {
              html += `<div class="text-black-lp-300">${item.sttDetails[x].totalPieces}</div>`;
            }
            html += `</div>`;
            return html;
          }
          return `<div class="text-black-lp-300 whitespace-no-wrap">
                  ${item.totalPieces}
                </div>`;
        }
      },
      {
        name: this.$t("Produk"),
        styleHead: "w-36 text-left whitespace-no-wrap",
        render: (item: any) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails) {
            for (const x in item.sttDetails) {
              html += `<div class="text-black-lp-300">${item.sttDetails[x].productType}</div>`;
            }
            html += `</div>`;
            return html;
          }
          return `<div class="text-black-lp-300 whitespace-no-wrap">
                  ${item.productType}
                </div>`;
        }
      },
      {
        name: this.$t("Komoditas"),
        styleHead: " w-60 text-left whitespace-no-wrap break-all",
        render: (item: any) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails) {
            for (const x in item.sttDetails) {
              html += `<div class="text-black-lp-300 break-all pr-6">${item.sttDetails[x].commodity}</div>`;
            }
            html += `</div>`;
            return html;
          }
          return `<div class="text-black-lp-300 whitespace-no-wrap break-all pr-6">
                  ${item.commodity}
                </div>`;
        }
      },
      {
        name: "Atur",
        key: "actionable_column",
        styleHead: "w-36 text-left whitespace-no-wrap",
        showButton: () => true
      }
    ];
  }

  isShowModalDeleteConfirmation = false;
  wordingDelete = "";
  itemToDelete: any = "";
  successModalDelete = false;

  get popUpDelete() {
    if (this.successModalDelete) {
      return {
        success: {
          action: () => {
            this.setSuccessModalDelete(false);
            this.onEditStt();
          },
          text: "OK"
        },
        title: this.$t("STT Berhasil Dihapus"),
        message: this.$t("Anda dapat menambahkan STT baru ke daftar pengiriman"),
        image: "image-modal-success"
      };
    }
    if (this.isShowModalDeleteConfirmation)
      return {
        success: {
          action: () => this.isDeleteCargoItem(),
          text: this.$t("Hapus")
        },
        cancel: {
          action: () => this.actionModalDelete(false),
          text: this.$t("Batal")
        },
        title: `${this.$t("Hapus")} STT?`,
        message: `${this.$t(this.wordingDelete)}`,
        image: "badge-confirmation-general"
      };
    return {
      success: {
        action: () => {
          this.setSuccessModalDelete(false);
        },
        text: "OK"
      },
      title: this.$t("STT Berhasil Dihapus"),
      message: this.$t("Anda dapat menambahkan STT baru ke daftar pengiriman"),
      image: "image-modal-success"
    };
  }

  // custom button
  customButton = {
    outline: true,
    iconLeft: "trash-red",
    title: this.isAccountForeign ? "Delete" : "Hapus",
    textColor: "red-lp-100",
    color: "red-lp-100",
    small: false,
    customClass: "whitespace-no-wrap",
    disabled: false,
    clickFunction: (item: any) => {
      if (!item.baggingNumber) {
        this.wordingDelete =
          "STT yang Anda hapus akan hilang dari daftar pengiriman";
      } else {
        this.wordingDelete =
          "Semua STT dari No. Bag yang sama akan terhapus dari daftar pengiriman";
      }
      this.itemToDelete = item;
      this.actionModalDelete(true);
    }
  };

  actionModalDelete(bool: boolean) {
    this.isShowModalDeleteConfirmation = bool;
    this.isUnpaid = false;
  }

  setSuccessModalDelete(bool: boolean) {
    this.successModalDelete = bool;
  }

  isDeleteCargoItem() {
    for (const sttDetail of this.itemToDelete.sttDetails) {
      this.sttNumberToDelete = sttDetail.sttNumber;
      this.onValidateDeleteSttNumber(sttDetail.sttNumber);
    }
    this.actionModalDelete(false);
    this.setSuccessModalDelete(true);
    this.isUnpaid = false;

    this.deleteDimensionPerKoliData();
  }

  // role account user
  get roleAccount() {
    return (
      (this.dataProfile.account_type === "partner"
        ? this.dataProfile.account_type_detail.type
        : this.dataProfile.account_type) || "internal"
    );
  }

  stringDecimalToDecimal(value: string | number) {
    return parseByCountry(`${value}`, { country: this.countryCode });
  }

  get isInternal() {
    return this.dataProfile.account_type === "internal";
  }

  withPrint = false;
  withPrintLabel = false;
  countSuccess = 0;
  countFailed = 0;
  async onSave(): Promise<void> {
    this.handleConfirmationSave(false);
    const itemsWithActionAdd = [...this.sttResult].filter(
      (item) => item.action === "add"
    );
    if (itemsWithActionAdd.length) {
      const elligible = await this.checkEligible();
      if (!elligible) return;
    }
    await this.calculateVolume(CargoController.calculateVolumeData.calculateType);
    await this.$nextTick();

    let payload: any = {
      cargoId: this.detailData.id,
      cargoNo: this.detailData.cargoNumber,
      actualTotalGrossWeight: this.actualCargoGrossWeightPayload,
      actualTotalVolumeWeight: this.actualCargoVolumeWeightPayload,
      bagOrStt: this.sttResult?.map(
        item =>
          new EditCargoBagOrStt(item.baggingNumber, item.sttNumber, item.action, item.isScanByBag)
      ),
      cargoActualPiece: Number(this.formEdit.actualTotalSTTPieces),
      actualDimension: this.formEdit.actualDimension,
      dimensions: this.mappingDetailPieces,
      photoProof: this.photoProof,
      cargoTotalEstimateGrossWeight: CargoController.totalNewCalculationGrossWeights,
      cargoTotalEstimateVolumeWeight: CargoController.totalNewCalculationVolumeWeights,
      cargoTotalChargeableWeight: this.totalSttChargeableWeight,
      cargoTotalCustomChargeableWeight: this.actualChargeableWeight,
      cargoTotalEstimateChargeableWeight: this.chargeableWeight,
      isNewCalculation:
        this.detailData.isUseNewCalculation ||
        flags.feature_hide_dimension_koli.isEnabled(),

      isValidAwbManual: this.detailData.isValidAwbManual,
      isCargoDimensionOn: this.detailData.isCargoDimensionOn,
      calculateType: CargoController.calculateVolumeData.calculateType,
      cargoTypeStatus: this.detailData.isPlaneManual ? "manual" : "auto",
      currentChargeableWeight: this.isMinimumVolumePerPiece
        ? CargoController.initCalculateVolumeData.chargeableWeight
        : this.chargeableWeight
    };

    // set payload when stt is empty
    if(this.isSttEmpty) {
      Object.assign(payload, {
        actualTotalGrossWeight: 0,
        actualTotalVolumeWeight: 0,
        cargoActualPiece: 0,
        actualDimension: new DimensionData({
          length: 30,
          width: 20,
          height: 10
        })
      })
    }

    payload = this.isInternal
      ? { ...payload, partnerId: this.detailData.partnerId }
      : payload;
    const resp = await CargoController?.onEditCargo(payload);
    this.onEditResponse(resp);
    this.handleConfirmationSave(false);
  }
  onEditResponse(resp: any) {
    if (resp) {
      CargoController.resetScanFailedList();

      if (resp.totalSttFailed > 0 && resp.totalSttSuccess === 0) {
        this.countFailed = resp.totalSttFailed;
        this.setFailed(true);
        CargoController.setSttFailed(resp.listSttFailed);
      } else if (resp.totalSttFailed > 0 && resp.totalSttSuccess > 0) {
        this.countFailed = resp.totalSttFailed;
        this.countSuccess = resp.totalSttSuccess;
        this.isPartial = true;
        CargoController.setSttFailed(resp.listSttFailed);
        this.onPrint();
      } else {
        CargoController.setOpenSuccess(true);
        this.onPrint();
      }

      // this.sttResult.splice(0, this.sttResult?.length);
    }
  }
  onPrint() {
    const refs: any = this.$refs;

    if (this.withPrint) {
      refs.print.printManifestV2(CargoController.cargoIdToGeneratePdf);
    }
    if (this.withPrintLabel) {
      refs.print.printData(CargoController.cargoIdToGeneratePdf, "label");
    }
  }

  formatDate(date: any) {
    date = new Date(date);
    return formatDateWithoutTime(date);
  }

  formatTimeNumber(date: any) {
    date = new Date(date);
    return formatTimeNumber(date).substring(0, 5);
  }

  formatNoDecimal(value: string) {
    return formatInputByCountry(value, { type: "quantity", country: this.countryCode });
  }

  formatFloat(value: string) {
    return formatInputByCountry(value, { type: "weight", country: this.countryCode });
  }

  formatDimension(value: string) {
    return formatInputByCountry(value, { type: "dimension", country: this.countryCode });
  }

  formatValue(value: string, type: string) {
    if (checkValueOnBlurInput(value) === "withoutComma") {
      const newValue = formatByCountry(Number(value), { type: "weight", country: this.countryCode });
      if (type === "grossWeight") {
        this.detailData.totalActualCargoGrossWeight = newValue;
      } else {
        this.detailData.totalActualCargoVolumeWeight = newValue;
      }
    } else if (checkValueOnBlurInput(value) === "oneValueAfterComma") {
      if (type === "grossWeight") {
        this.detailData.totalActualCargoGrossWeight = value + "0";
      } else {
        this.detailData.totalActualCargoVolumeWeight = value + "0";
      }
    } else if (checkValueOnBlurInput(value) === "minimumValue") {
      const sep = this.countryCode === "MY" ? "." : ",";
      const newValueMinimum = value.split(sep)[0];
      const zeroTen = this.countryCode === "MY" ? ".10" : ",10";
      if (type === "grossWeight") {
        this.detailData.totalActualCargoGrossWeight = newValueMinimum + zeroTen;
      } else {
        this.detailData.totalActualCargoVolumeWeight = newValueMinimum + zeroTen;
      }
    }
  }

  createAndPrint(withPrint: boolean, label = false) {
    const refs: any = this.$refs;
    refs.op?.hide();
    this.withPrint = withPrint;
    this.withPrintLabel = label;
    this.handleConfirmationSave(true);
  }

  // handle route leave and modal
  // navigation
  get openSuccess(): boolean {
    return CargoController.isOpenSuccess;
  }
  setOpenSuccess(value: boolean) {
    CargoController.setOpenSuccess(value);
  }

  // failed for create
  get isFailed(): boolean {
    return CargoController.isFailed;
  }
  setFailed(value: boolean) {
    CargoController.setFailed(value);
  }

  openConfirmationLeave = false;
  openConfirmationSave = false;
  answer = false;
  newPath = "";
  handleConfirmationLeave(value: boolean) {
    this.openConfirmationLeave = value;
  }
  handleConfirmationSave(value: boolean) {
    this.openConfirmationSave = value;
  }
  goBack() {
    const idQuery = this.cargoId ? `?id=${this.cargoId}` : "";
    this.$router.push(`${this.$route.matched[0].path}/${this.cargoNo}${idQuery}`);
  }
  onOpenClosePage(to: any) {
    this.handleConfirmationLeave(true);
    this.newPath = to.path;
  }
  handlerClose() {
    this.handleConfirmationLeave(false);
    this.answer = true;
    this.$router.push(this.newPath);
    CargoController.setDimensionPerKoliDataEdit(
      new DimensionPerKoliData({
        totalPieces: 0,
        dimensionPieces: []
      })
    );
    this.onResetCargoFailedScanFromStorage();
  }
  handlerCancelClose() {
    this.answer = false;
    this.handleConfirmationLeave(false);
  }
  onCloseSuccess() {
    this.setOpenSuccess(false);
    this.answer = true;
    this.goBack();
    CargoController.setDimensionPerKoliDataEdit(
      new DimensionPerKoliData({
        totalPieces: 0,
        dimensionPieces: []
      })
    );
    this.onResetCargoFailedScanFromStorage();
  }

  volumeWeightCalculate(dimension: {
    length: number;
    width: number;
    height: number;
  }): number {
    const divider = getConfigDimensionDivider(this.detailData.cargoType);
    const rawWeight = (dimension.length * dimension.width * dimension.height) / divider;
    return Number(rawWeight !== 0 ? rawWeight : 0);
  }


  get isAccountForeign() {
    return AccountController.accountData.accountIsForeign;
  }

  get dimensionDividerPlane() {
    return CargoController.dimensionDivider;
  }

  get showEditDimensiPerKoliV1() {
    return flags.feature_hide_dimension_koli.isEnabled();
  }

  get showNewDimensionPerKoli() {
    const showEditDimensiPerKoliV1 = flags.feature_hide_dimension_koli.isEnabled();
    const validation = (
      this.detailData.cargoType === "plane" &&
      this.detailData.isPlaneManual === false && 
      !!this.detailData.cargoDimensionCustom?.[0]?.sttOrBag
    );

    if (!showEditDimensiPerKoliV1 && validation) CargoController.setIsCargoDimensionOn(true)
    if (showEditDimensiPerKoliV1 && !validation) CargoController.setIsCargoDimensionOn(false)

    return (
      this.detailData.cargoType === "plane" &&
      this.detailData.isPlaneManual === false && 
      !!this.detailData.cargoDimensionCustom?.[0]?.sttOrBag
    );
  }

  get isHaveBeenSubmitDetailPieces() {
    return CargoController.isHaveBeenSubmitDetailPieces;
  }

  get formDetailPieces() {
    return CargoController.formDetailPieces;
  }

  mappingDimensionPerKoli() {
    const updatedDimensionPerKoli = this.detailData.cargoDimensionCustom.map(
      (item: any) =>
        new DimensionPerKoliDetail({
          sttOrBag: item.sttOrBag,
          sttPieceLength: item.length,
          sttPieceWidth: item.width,
          sttPieceHeight: item.height,
          sttPieceGrossWeight: item.grossWeight,
          sttPieceVolumeWeight: this.volumeWeightCalculate({
            length: item.length,
            width: item.width,
            height: item.height
          })
        })
    );

    // Set the updated dimension per koli data to CargoController
    CargoController.setDimensionPerKoliDataEdit(
      new DimensionPerKoliData({
        dimensionPieces: updatedDimensionPerKoli
      })
    );
  }

get mappingDetailPieces() {
    if (!this.showEditDimensiPerKoliV1 && this.showNewDimensionPerKoli) {
      return CargoController.dimensionPerKoliDataEdit.dimensionPieces.map(
        (item: DimensionPerKoliDetail) => ({
          // eslint-disable-next-line @typescript-eslint/camelcase
          stt_or_bag: item.sttOrBag,
          pieces: item.totalPieces,
          length: item.sttPieceLength,
          width: item.sttPieceWidth,
          height: item.sttPieceHeight,
          // eslint-disable-next-line @typescript-eslint/camelcase
          gross_weight: item.sttPieceGrossWeight,
          // eslint-disable-next-line @typescript-eslint/camelcase
          volume_weight: item.sttPieceVolumeWeight
        })
      );
    } else {
      return [{
        // eslint-disable-next-line @typescript-eslint/camelcase
        pieces: Number(this.detailData.cargoActualPiece),
        length: this.formEdit.actualDimension.length,
        width: this.formEdit.actualDimension.width,
        height: this.formEdit.actualDimension.height,
        // eslint-disable-next-line @typescript-eslint/camelcase
        gross_weight: this.actualCargoGrossWeightPayload,
        // eslint-disable-next-line @typescript-eslint/camelcase
        volume_weight: this.actualCargoVolumeWeightPayload
      }];
    }
  }

  
    hasBagDimensions(bag: any): boolean {
    return !!(
      bag?.bagCustomLength &&
      bag?.bagCustomWidth &&
      bag?.bagCustomHeight
    );
  }
  createBagDimensionDetail(item: any): DimensionPerKoliDetail {
    return new DimensionPerKoliDetail({
      sttOrBag: this.getSttOrBag(item),
      sttPieceGrossWeight: this.getGrossWeight(item),
      sttPieceVolumeWeight: this.getVolumeWeight(item),
      sttPieceLength: this.getLength(item),
      sttPieceWidth: this.getWidth(item),
      sttPieceHeight: this.getHeight(item)
    });
  }

  getSttOrBag(item: any): string {
    return item.baggingVendorNo || item.baggingNumber;
  }

  getGrossWeight(item: any): number {
    return item.bagData?.bagCustomGrossWeight;
  }

  getVolumeWeight(item: any): number {
    return this.calculateVolumeWeight(
      item.bagData?.bagCustomLength,
      item.bagData?.bagCustomWidth,
      item.bagData?.bagCustomHeight
    );
  }

  getLength(item: any): number {
    return item.bagData?.bagCustomLength;
  }

  getWidth(item: any): number {
    return item.bagData?.bagCustomWidth;
  }

  getHeight(item: any): number {
    return item.bagData?.bagCustomHeight;
  }
  createPieceDimensionDetails(item: any) {
    return item?.sttPieces?.length
      ? item.sttPieces.map(
          (piece: CargoDetailSttPiece, index: number) =>
            new DimensionPerKoliDetail({
              sttOrBag: `${item.sttNumber} #${index + 1}`,
              sttPieceGrossWeight: piece.sttPieceGrossWeight,
              sttPieceVolumeWeight: this.calculateVolumeWeight(
                piece.sttPieceLength,
                piece.sttPieceWidth,
                piece.sttPieceHeight
              ),
              sttPieceLength: piece.sttPieceLength,
              sttPieceWidth: piece.sttPieceWidth,
              sttPieceHeight: piece.sttPieceHeight
            })
        )
      : [];
  }
  calculateVolumeWeight(length: number, width: number, height: number): number {
    const divider = getConfigDimensionDivider(this.detailData.cargoType);
    return (
      (length * width * height) / divider
    );
  }

  get actualCargoVolumeWeightPayload() {
    return this.getActualCargoWeight(
      CargoController.dimensionPerKoliDataEdit.actualVolumeWeight,
      this.formEdit.actualTotalCargoVolumeWeight
    );
  }

  get actualCargoGrossWeightPayload() {
    return this.getActualCargoWeight(
      CargoController.dimensionPerKoliDataEdit.actualGrossWeight,
      this.formEdit.actualTotalCargoGrossWeight
    );
  }

  get isValidDimension(): boolean {
    return CargoController.dimensionPerKoliDataEdit.dimensionPieces.every(
      e => e.sttOrBag
    );
  }

  get isPlaneAuto() {
    return this.detailData.cargoType === "plane";
  }

  private getActualCargoWeight(dimensionWeight: number, totalWeight: string) {
    const dimensionsPlaneAuto =
      !flags.feature_hide_dimension_koli.isEnabled() &&
      this.isValidDimension &&
      this.isPlaneAuto;

    return dimensionsPlaneAuto
      ? dimensionWeight
      : commaDecimalToDecimal(totalWeight);
  }

  deleteDimensionPerKoliData() {
    CargoController.setIsSttUpdated(CargoController.isDimensionSaved);

    const {
      sttNumber,
      baggingNumber,
      baggingVendorNo,
      baggingVendorNumber
    } = this.itemToDelete;

    const newDimensionData = CargoController.dimensionPerKoliDataEdit.dimensionPieces.filter(
      (item) =>
        !(
          (sttNumber && item.sttOrBag.includes(sttNumber)) ||
          (baggingNumber && item.sttOrBag.includes(baggingNumber)) ||
          (baggingVendorNo && item.sttOrBag.includes(baggingVendorNo)) ||
          (baggingVendorNumber && item.sttOrBag.includes(baggingVendorNumber))
        )
    );

    CargoController.setDimensionPerKoliDataEdit(
      new DimensionPerKoliData({
        totalPieces: newDimensionData.length,
        dimensionPieces: newDimensionData
      })
    );
  }

  async onUploadAdjustmentWeight(params: UploadMultiple) {
    if (!params.file) return;

    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      const fileLink = await BookingController.uploadHydraFile(
        new UploadHydraFileRequest({
          attachFile: params.file,
          folderPath: "stt/"
        })
      );
      this.photoProof[params.index] = fileLink.data;
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, this.$t("bookingShipment.error.uploadPhoto"))
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  async onRemoveAdjustmentWeight(index: number) {
    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      const res = await BookingController.deleteHydraFile(
        new DeleteHydraFileRequest({
          attachFiles: [this.photoProof[index]]
        })
      );
      const statusDel = res.data[this.photoProof[index]];

      if (statusDel) {
        this.photoProof[index] = "";
      }
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, "Gagal menghapus Foto ke storage!")
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  resetUploadPhotoCondition() {
    this.isGrossWeightDiff = false;
    this.openAdjustmentWeight = true;
    this.isFirstLanding = true;
    this.isGrossWeightChanged = false;
    this.photoProof = [];
    this.tempGrossWeight = 0;
    this.isTempGrossWeightSet = false;
  }

  private parseNumber(value: string) {
    if (typeof value === "number") return value;
    return value ? parseByCountry(value, { country: this.countryCode }) : 0;
  }

  isDimensionChanged = true;
  isEditFirstLanding = true;

  get sttCalculation() {
    return {
      grossWeight: this.totalGrossWeight,
      volumeWeight: this.totalVolumeWeight
    };
  }
  get chargeableWeight() {
    return this.sttResultFinal.length
      ? Math.max(
          1,
          CargoController.totalNewCalculationGrossWeights,
          CargoController.totalNewCalculationVolumeWeights
        )
      : 0;
  }
  get actualChargeableWeight() {
    return CargoController.calculateVolumeData.chargeableWeight;
  }
  get totalSttChargeableWeight() {
    return CargoController.totalSttChargeableWeight;
  }
  get isErrorChargeableWeight() {
    const isError = !this.isEditFirstLanding && CargoController.calculateVolumeData.isUploadProofPhoto;
    if (!isError) this.photoProof = [];
    return isError;
  }

  get isShowUploadPhotoSection() {
    return this.isValidationAdjustWeightProofPhotoEnable && this.isErrorChargeableWeight;
  }

  async calculateVolume(calculateType = "", isScan = false, mounted = false){
    await this.$nextTick();

    if (!this.sttResultFinal?.length) {
      CargoController.setCalculateVolumeData();
      this.formEdit.actualTotalCargoVolumeWeight = 0 as any;
      return;
    }

    const minVolumePerPiece = getConfigMinimumVolumePerPiece(this.formEdit.cargoType, this.detailData.isPlaneManual ? "manual" : "auto");
    CargoController.calculateVolume(new CalculateVolumeApiRequest({
      calculateType,
      calculateRequest: new CalculateVolumeRequest({
        cargoType: this.formEdit.cargoType,
        chargeableWeightReweigh: this.chargeableWeight,
        currentGrossWeight: this.parseNumber(this.formEdit.actualTotalCargoGrossWeight),
        height: this.formEdit.actualDimension.height,
        length: isScan ? 90 : this.formEdit.actualDimension.length,
        width: isScan ? 60 : this.formEdit.actualDimension.width,
        totalPieces: this.formEdit.actualTotalSTTPieces,
        volumeWeightReweigh: this.parseNumber(this.totalNewCalculationVolumeWeights as any),
        divider: getConfigDimensionDivider(this.formEdit.cargoType),
        isMinimumVolumePerPiece: mounted ? this.detailData.isMinimumVolumePerPiece : this.isMinimumVolumePerPiece,
        minVolumePerPiece: mounted ? this.detailData.minVolumePerPiece : minVolumePerPiece,
      }),
    }))
  }

  get isMinimumVolumePerPiece() {
    return getConfigIsminimumVolumePerPiece(this.formEdit.cargoType, this.detailData.isPlaneManual ? "manual" : "auto");
  }

  get isLoadingCalculateVolume() {
    return CargoController.isLoadingCalculateVolume;
  }
  async checkEligible() {
    const tempSttResult = [...this.sttResultFinal].filter(
      (item) => item.action === "add"
    );
    const tempBagResult = [...this.sttResultFinal].filter(
      (item) => item.action === "add"
    );
    const stts = tempSttResult
      .filter((stt) => !stt.baggingNumber)
      .map((stt) => {
        return new AddBagOrStt(undefined, stt.sttNumber);
      });
    const bags = tempBagResult
      .filter((bag) => bag.baggingNumber)
      .map((bag) => {
        return new AddBagOrStt(bag.baggingNumber);
      });

    const payload = new RequestCheckEligibleReadyToCargo({
      bagOrStt: [...stts, ...bags]
    });
    try {
      MainAppController.showLoading();
      const res = await CargoController.checkEligible(payload);
      if (res.isEligible) {
        return true;
      } else {
        const stts = res.bagOrStt.map((item) => item.sttNo);
        const bags = res.bagOrStt.map((item) => item.bagNo);

        const sttResult = tempSttResult.filter((stt) => {
          if (!stts.length) return [];
          return stts.includes(stt.sttNumber);
        });

        const bagResult = tempBagResult
          .filter((bag) => !!bag.baggingNumber)
          .filter((bag) => {
            if (!bags.length) return [];
            return bags.includes(bag.baggingNumber);
          });

        for (const stt of sttResult) {
          this.itemToDelete = stt;
          await nextTick();
          this.isDeleteCargoItem();
          await nextTick();
          await new Promise((resolve) => {
            setTimeout(() => {
              resolve(true);
            }, 200);
          });
        }

        for (const bag of bagResult) {
          this.itemToDelete = bag;
          await nextTick();
          this.isDeleteCargoItem();
          await nextTick();
          await new Promise((resolve) => {
            setTimeout(() => {
              resolve(true);
            }, 200);
          });
        }

        this.setSuccessModalDelete(false);

        MainAppController.showMessageModal(
          new ModalMessageEntities({
            image: "badge-warning-lg",
            title: this.$t("cargoV2.components.common.sttBagCannotUpdateTitle"),
            message: this.$t("cargoV2.components.common.sttBagCannotUpdateMessage"),
            textSuccess: "Cek Data",
            onSubmit: async () => {
              MainAppController.closeMessageModal();
            }
          })
        );
        return false;
      }
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, this.$t("cargoV2.components.common.errorCheckEligible"), () =>
          this.checkEligible()
        )
      );
      return false;
    } finally {
      MainAppController.closeLoading();
    }
  }
}
